export const AdjustStartPageUrl = 'https://app.adjust.com/112zb57z_116hd4yn'
